import {OAuthModuleConfig} from 'angular-oauth2-oidc';

export const authModuleConfig: OAuthModuleConfig = {
    resourceServer: {
        allowedUrls: ['https://us-central1-aa-fos-uat-mobile.cloudfunctions.net/app/profile', 'https://us-central1-aa-fos-mobile.cloudfunctions.net/app/profile', 'https://us-central1-aa-fos-uat-mobile.cloudfunctions.net/app/hkairportrewards/services/oauth2/revoke', 'https://us-central1-aa-fos-uat-mobile.cloudfunctions.net/app/hkairportrewards/services/oauth2/userinfo', 'https://hkairportloyalty--sit.sandbox.my.site.com', 'https://api.iss.hkairportrewards.com', 'https://hkia.mp.sit.acnhk.com'],
        sendAccessToken: true,
    }
};
